import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { Hashsum, PackageUpsaleOptionsStateType } from './types';

export const name = 'packageUpsaleOptions';

const initialState: PackageUpsaleOptionsStateType = {
  extraOptions: [],
  transferOptions: [],
  chosenOptions: [],
};

// Доп услуги на странице чекаута собранные из api
const packageUpsaleOptions = createSlice({
  name,
  initialState,
  reducers: {
    fetchSuccess(state, action: PayloadAction<PackageUpsaleOptionsStateType>) {
      state.extraOptions = action.payload.extraOptions;
      state.transferOptions = action.payload.transferOptions;
    },
    fetchError(state) {
      state.extraOptions = [];
      state.transferOptions = [];
    },
    setOptions(state, action: PayloadAction<Hashsum>) {
      state.chosenOptions = [...state.chosenOptions, action.payload];
    },
    clearOptions: () => initialState,
    uncheckOption: (state, action: PayloadAction<Hashsum>) => {
      const filteredChosenOptions = state.chosenOptions.filter(
        (hashsum) => hashsum !== action.payload,
      );
      state.chosenOptions = filteredChosenOptions;
    },
  },
});

// export
export const {
  fetchSuccess,
  fetchError,
  setOptions,
  clearOptions,
  uncheckOption,
} = packageUpsaleOptions.actions;
export default packageUpsaleOptions.reducer;
